import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { WebappRoutingModule } from './webapp-routing.module';
import { HomeComponent } from './home/home.component';
import { CampaignListComponent } from './campaign/campaign-list/campaign-list.component';
import { CampaignDetailComponent } from './campaign/campaign-detail/campaign-detail.component';
import { RestaurantListComponent } from './restaurant/restaurant-list/restaurant-list.component';
import { RestaurantDetailComponent } from './restaurant/restaurant-detail/restaurant-detail.component';
import { DownloadComponent } from './download/download.component';
import { TermsComponent } from './public/terms/terms.component';
import { SharedModule } from '../../shared/shared.module';
import { PlansComponent } from './public/plans/plans.component';
import { PlansTableComponent } from './public/plans/plans-table/plans-table.component';
import { PlansCardsComponent } from './public/plans/plans-cards/plans-cards.component';
import { CategoryComponent } from './category/category.component';
import { PerformanceComponent } from './public/performance/performance.component';
import { DeliveryListComponent } from './delivery/delivery-list/delivery-list.component';
import { AppExclusionTutorialComponent } from './app-exclusion-tutorial/app-exclusion-tutorial.component';
import { EventComponent } from './event/event.component';
import { DynamicLinkComponent } from './dynamic-link/dynamic-link.component';

@NgModule({
  declarations: [
    HomeComponent,
    CampaignListComponent,
    CampaignDetailComponent,
    RestaurantListComponent,
    RestaurantDetailComponent,
    DownloadComponent,
    TermsComponent,
    PlansComponent,
    PlansTableComponent,
    PlansCardsComponent,
    CategoryComponent,
    PerformanceComponent,
    DeliveryListComponent,
    AppExclusionTutorialComponent,
    EventComponent,
    DynamicLinkComponent,
  ],
  imports: [CommonModule, NgOptimizedImage, SharedModule, WebappRoutingModule],
})
export class WebappModule {}
